module.exports = __webpack_public_path__ + "static/img/bb1.01feaa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bb1.jpg
// module id = q3+V
// module chunks = 1